import styled from 'styled-components';
import { BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface ItemInfosProps extends BaseStyledComponentProps {
	isRowView: boolean;
}

interface ItemLabelProps extends BaseStyledComponentProps {
	isRowView: boolean;
}

const itemRowImageSize = '150px';
const itemInfosHorizontalPadding = '13px';

const ItemInfos = styled('div')`
	${(props: ItemInfosProps) => props.isRowView
		? 	`padding: 15px ${itemInfosHorizontalPadding};
			width: calc(100% - ${itemRowImageSize} - 2 * ${itemInfosHorizontalPadding});
			background-color: ${props.theme.primary.cardColor};
			border-radius: 0 9px 9px 0;`
		: 	`padding: 15px 5px;
			height: 40px;`
	}
`;

const ItemLabel = styled('span')`
	${(props: ItemLabelProps) => props.isRowView
		?	`font-size: 14px;
			position: relative;
			top: -4px;`
		:	`font-size: 16px;
			width: calc(100% - 40px);`
	}

	${(props: ItemLabelProps) => props.isRowView
		?	`/* The max-height and display block are for IE not recognizing display box and line-clamp */
			display: block;
			max-height: 75px;

			display: -webkit-box;
			-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;`
		:	`display: block;
			white-space: nowrap`
	}
	font-weight: 500;
	color: ${(props: ItemLabelProps) => props.theme.primary.contentColor};
	text-overflow: ellipsis;
	letter-spacing: 0.7px;
	line-height: 1.3;
	overflow: hidden;
`;

const ItemSubLabel = styled('span')`
	font-size: 12px;
	${(props: ItemLabelProps) => props.isRowView
		?	`top: -2px;`
		:	`top: 3px;`
	}
	position: relative;
	vertical-align: text-top;
	color: ${(props: ItemLabelProps) => hexToRgba(props.theme.primary.contentColor, 50)};
	letter-spacing: 0.5px;
	line-height: 1.3;

	> svg {
		display: inline-block;
	}
`;

export {
	ItemInfos,
	ItemLabel,
	ItemSubLabel,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/Infos/styles.ts